import gql from 'graphql-tag';

export const DELETE_POST = gql`
  mutation deletePost($postId: Int!) {
    post {
      delete(postId: $postId)
    }
  }
`;
